import React, { FC } from 'react';
import ModalFooter from 'components/appModalFooter';
import { Popup } from 'devextreme-react';

interface Props {
  open: boolean;
  title?: string;
  message?: string;
  textConfirmButton?: string;
  textDismissButton?: string;
  onConfirm: () => void;
  onClose: () => void;
  onDismiss: () => void;
  width?: number;
  height?: number;
  isButtonCloseShown?: boolean;
  isLoading?: boolean;
  typeConfirm?:  'danger' | 'default' | 'normal' | 'success' | undefined
}

const ConfirmDialog: FC<Props> = ({
  open,
  title,
  message,
  width = 400,
  height = 160,
  textConfirmButton,
  onConfirm,
  onClose,
  onDismiss,
  isLoading,
  typeConfirm = 'default'
}) => {

  return (
    <Popup
      visible={open}
      onHiding={onClose}
      dragEnabled={true}
      closeOnOutsideClick={false}
      showTitle={true}
      title={title || 'Подтвердите действие'}
      width={width}
      height={height}
    >
      <div className="modal-block">
        <form>
          <div className="modal-block__content">
            { message }
          </div>

          <ModalFooter
            useSubmitBehavior={false}
            handleSubmit={onConfirm}
            hideModal={onDismiss}
            textConfirm={textConfirmButton || 'Подтвердить'}
            typeConfirm={typeConfirm}
            disabledSubmit={isLoading}
          />
        </form>
      </div>
    </Popup>
  );
};

export default ConfirmDialog;
